(ns ui.wallet.i18n.pt
  "Portuguese (Brazil) dictionary of the wallet page (see
   `ui.wallet.i18n`).")

(def dictionary
  {:page/loading "carregando..."
   :page/command-failed "Algo deu errado. Tente novamente ou fale conosco pelo chat se continuar acontecendo."

   :balance/total-available "Saldo disponível"
   :balance/pay-as-you-go "Saldo pré-pago"
   :balance/used-up "Adicione créditos para continuar publicando."
   :balance/view-usage "Ver consumo"

   :payment/title "Pagamento"
   :payment/method "Forma de pagamento"
   :payment/billing-email "E-mail de cobrança"
   :payment/reference "Referência"
   :payment/update "Alterar forma de pagamento"
   :payment/card [:fn/str "Cartão ({{:last4}})"]
   :payment/wire-transfer "Transferência bancária"

   :billing-email/change "Alterar"
   :billing-email/new "Novo e-mail de cobrança"
   :billing-email/save "Salvar"
   :billing-email/saving "Salvando..."
   :billing-email/cancel "Cancelar"
   :billing-email/hint "A Paddle, nossa revendedora, envia recibos e faturas para este endereço."
   :billing-email/shared-hint "Se várias das suas organizações compartilham esta conta de cobrança, a alteração vale para todas."
   :billing-email/invalid "Insira um endereço de e-mail válido."
   :billing-email/taken "Este endereço de e-mail já é usado por outra conta de cobrança. Use outro endereço ou fale conosco pelo chat."

   :customer-conflict/title "Seu e-mail já está vinculado a outra conta"
   :customer-conflict/text "Seu endereço de e-mail já pertence à conta de cobrança de outra organização do Storrito, e nosso provedor de pagamentos Paddle permite apenas uma conta de cobrança por e-mail. Fale conosco pelo chat e resolvemos para você."
   :customer-conflict/chat "Abrir o chat de suporte"
   :customer-conflict/support-message "Olá, não consigo abrir o checkout: meu endereço de e-mail já pertence a outra conta de cobrança."

   :top-up/title "Recarga automática"
   :top-up/custom-amount "Valor personalizado"
   :top-up/opening-checkout "Abrindo o pagamento..."
   :top-up/amount-missing "Informe um valor."
   :top-up/amount-too-small [:fn/str "O mínimo é ${{:minimum}}."]
   :top-up/amount-too-large [:fn/str "O máximo é ${{:maximum}} por recarga. Para valores maiores, fale conosco pelo chat."]
   :top-up/per-month [:fn/str "${{:quantity}} todo mês"]
   :top-up/per-year [:fn/str "${{:quantity}} todo ano"]
   :top-up/stops-on [:fn/str "Termina em {{:date}}"]
   :top-up/next-on [:fn/str "Próxima recarga em {{:date}}"]
   :top-up/status-cancellation-scheduled "cancelamento agendado"
   :top-up/status-payment-failed "pagamento recusado"
   :top-up/status-active "ativa"
   :top-up/past-due "A última recarga não pôde ser cobrada. "
   :top-up/update-payment-method "Atualize sua forma de pagamento"
   :top-up/resume "Retomar a recarga automática"
   :top-up/cancel "Cancelar a recarga automática"
   :top-up/paddle-unavailable "Não conseguimos carregar os dados da sua recarga automática no Paddle agora. Tente novamente em instantes."
   :top-up/try-again "Tentar novamente"

   :plan/title-monthly "Recarga mensal"
   :plan/title-yearly "Recarga anual"
   :plan/switch "Mudar para pré-pago sem recorrência"
   :plan/switching "Mudando..."
   :plan/switch-confirm [:fn/str "Sua recarga recorrente de ${{:quantity}} termina agora; a mudança é gratuita. Seu saldo e sua forma de pagamento permanecem. A partir daí você só paga quando adiciona créditos, ou automaticamente com a recarga automática."]
   :plan/wont-cover [:fn/str "Seu saldo provavelmente não cobre suas contas do Instagram conectadas até a próxima recarga em {{:date}}; as stories param de ser publicadas ao chegar a $0."]
   :plan/wont-cover-advice "Ative abaixo a recarga automática ou adicione créditos agora."

   :on-demand/add-credits "Adicionar créditos"
   :on-demand/choose-amount "Escolha um valor. Você só paga pelo que usa."
   :on-demand/auto-top-up "Recarga automática"
   :on-demand/rule [:fn/str "Quando seu saldo ficar abaixo de ${{:threshold}}, adicionamos ${{:amount}} automaticamente."]
   :on-demand/auto-top-up-hint "Opcional. Seus stories continuam sendo publicados quando o saldo fica baixo — você pode desativar a qualquer momento."
   :on-demand/add [:fn/str "Adicionar ${{:amount}}"]
   :on-demand/charged-once "Cobrado uma única vez agora pelo Paddle, nosso revendedor. Seu cartão fica salvo para futuras recargas, nada recorrente. Créditos não são reembolsáveis. Preços sem impostos."
   :on-demand/discount-off [:fn/str "{{:percent}}% de desconto em"]
   :on-demand/discount-applied "Aplicado à sua tarifa diária a partir da sua primeira recarga, não ao valor que você adiciona. Os créditos de boas-vindas são cobrados à tarifa normal."
   :on-demand/charged-to-card "Cobrado na sua forma de pagamento salva, disponível em segundos."
   :on-demand/confirm-charge [:fn/str "Serão cobrados agora ${{:amount}} USD sem impostos."]
   :on-demand/charging "Cobrando..."
   :on-demand/add-now [:fn/str "Adicionar ${{:amount}} agora"]
   :on-demand/payment-accepted "Pagamento aceito, seu saldo é atualizado em alguns segundos."
   :on-demand/prices-excl-vat "Preços sem impostos."
   :on-demand/amount-too-large [:fn/str "O máximo é ${{:maximum}} por recarga."]
   :on-demand/on "Ligada"
   :on-demand/off "Desligada"
   :on-demand/saving "Salvando..."
   :on-demand/save "Salvar"
   :on-demand/custom-auto-top-up-amount "Valor personalizado da recarga automática"
   :on-demand/one-charge-per-day "No máximo uma cobrança automática por dia, na sua forma de pagamento salva, mais os impostos aplicáveis."
   :on-demand/remove-payment-method "Remover forma de pagamento"

   :transactions/title "Transações recentes"
   :transactions/full-statement "Extrato completo"
   :transactions/invoices "Faturas"
   :transactions/date "Data"
   :transactions/description "Descrição"
   :transactions/amount "Valor"
   :transactions/error "Não foi possível carregar as transações."
   :transactions/empty "Ainda nenhuma compra este mês."
   :transactions/welcome-credits "Créditos de boas-vindas"
   :transactions/recurring-top-up "Recarga recorrente"
   :transactions/added-credits "Créditos adicionados"
   :transactions/refund "Reembolso de créditos"

   :credit-notes/view "Notas de crédito"
   :credit-notes/title "Notas de crédito"
   :credit-notes/intro "Notas de crédito dos seus reembolsos e créditos. Emitidas pela Paddle, nossa revendedora."
   :credit-notes/refund "Reembolso"
   :credit-notes/credit "Crédito"
   :credit-notes/download "Baixar PDF"
   :credit-notes/empty "Ainda não há notas de crédito."
   :credit-notes/error "Não foi possível carregar as notas de crédito."

   :offer/applied-automatically "Aplicado automaticamente quando você adiciona créditos. Até lá, os créditos de boas-vindas são cobrados à tarifa normal."

   :rates/view "Ver nossas tarifas"
   :rates/title "Nossas tarifas em resumo"
   :rates/intro "Veja o que cobramos por serviço. "
   :rates/intro-bold "Todos os preços em dólares americanos, sem impostos."
   :rates/per-day "por dia"
   :rates/per-post "por publicação"
   :rates/per-image "por imagem"
   :rates/per-days [:fn/str "por {{:days}} dias"]
   :rates/excl-vat "Todos os preços sem impostos"
   :rates/off [:fn/str "{{:percent}}% OFF"]

   :service.storage-flat-fee/name "Taxa fixa de armazenamento"
   :service.storage-flat-fee/description "para todas as suas imagens, vídeos etc."
   :service.instagram-connection/name "Conexão de conta do Instagram"
   :service.instagram-connection/description "Stories e Reels ilimitados para um nome de usuário do Instagram."
   :service.tiktok-post/name "Publicação no TikTok"
   :service.tiktok-post/description "Publique um vídeo ou uma imagem no TikTok."
   :service.youtube-short/name "YouTube Short"
   :service.youtube-short/description "Publique um vídeo renderizado como YouTube Short."
   :service.social-post/name "Publicação social"
   :service.social-post/description "Publique um vídeo renderizado ou uma imagem no Facebook, no Threads e em outras plataformas conectadas (o X é cobrado à parte)."
   :service.x-post/name "Publicação no X"
   :service.x-post/description "Publique um vídeo renderizado no X. O X cobra por cada publicação feita pela sua API, por isso as publicações no X custam mais do que outras publicações sociais."
   :service.x-post-link/name "Publicação no X com link"
   :service.x-post-link/description "Uma publicação no X cujo texto contém um link. O X cobra muito mais por publicações com links."
   :service.ai-image/name "Imagem com IA"
   :service.ai-image/description "Geração de uma imagem com IA (Dall-e / Blackforest)."})
